import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import dataV from '@jiaminghi/data-view'
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.use(dataV);

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js